<template>
  <div class="md-layout">
    <md-autocomplete
      v-model="selectedSensorVirtual"
      md-dense
      :md-options="sensoresVirtuais"
      :disabled="loading || sending"
      :required="required"
      :class="getValidationClass()"
      @md-changed="handleChange"
      @md-closed="handleClose"
    >
      <label>{{ label }}</label>
      <template slot="md-autocomplete-item" slot-scope="{ item, term }">
        <md-highlight-text :md-term="term">
          {{ item }}
        </md-highlight-text>
      </template>

      <template slot="md-autocomplete-empty" slot-scope="{ term }">
        Nenhum sensor virtual correspondente a "{{ term }}" foi encontrado.
      </template>

      <span v-if="validation && !validation.required" class="md-error">
        {{ label }} é obrigatório
      </span>
    </md-autocomplete>
  </div>
</template>

<script>
import querySensoresVirtuaisMixin from '@/mixins/query.mixin'

export default {
  name: 'SensorVirtualAutocomplete',
  mixins: [querySensoresVirtuaisMixin],
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    localId: {
      type: String,
      required: true,
    },
    shouldFilterOutSensorVirtualFn: {
      type: Function,
      default: () => false,
    },
    label: {
      type: String,
      default: 'Sensor Virtual',
    },
    value: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      default: null,
    },
    sending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sensoresVirtuais: [],
      selectedSensorVirtual: null,
      loading: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(sensorVirtualId) {
        this.updateSelectedSensorVirtual(sensorVirtualId)
      },
    },
    equipamentosComSensoresVirtuais() {
      this.loading = true
      try {
        this.sensoresVirtuais = Object.values(
          this.equipamentosComSensoresVirtuais
        ).flatMap((equipamento) => {
          return equipamento.sensoresVirtuais.reduce((acc, sensorVirtual) => {
            if (this.shouldFilterOutSensorVirtualFn(sensorVirtual)) return acc
            const sensorVirtualTitulo = `${equipamento.nome} - ${
              sensorVirtual.titulo || sensorVirtual.descricao
            }`
            acc.push({
              sensorVirtualId: sensorVirtual.id,
              sensorVirtualTitulo,
              toLowerCase: () => sensorVirtualTitulo.toLowerCase(),
              toString: () => sensorVirtualTitulo,
            })
            return acc
          }, [])
        })
      } catch (error) {
        console.error('Erro ao buscar sensores virtuais:', error)
      } finally {
        this.loading = false
      }
    },
    sensoresVirtuais() {
      this.$nextTick(() => {
        this.updateSelectedSensorVirtual(this.value)
      })
    },
  },
  methods: {
    updateSelectedSensorVirtual(sensorVirtualId) {
      if (sensorVirtualId === null) return (this.selectedSensorVirtual = null)
      this.selectedSensorVirtual =
        this.sensoresVirtuais.find(
          (s) => s.sensorVirtualId === sensorVirtualId
        ) || null
    },
    getValidationClass() {
      if (!this.validation) return
      return {
        'md-invalid': this.validation.$invalid && this.validation.$dirty,
      }
    },
    handleChange() {
      this.$emit(
        'input',
        typeof this.selectedSensorVirtual === 'object'
          ? this.selectedSensorVirtual.sensorVirtualId
          : null
      )
    },
    async handleClose() {
      // Delay to allow the input to update before clearing
      await new Promise((resolve) => setTimeout(resolve, 300))
      if (typeof this.selectedSensorVirtual === 'object') return
      this.selectedSensorVirtual = null
    },
  },
}
</script>
